import {
    Button,
    Card,
    CardActionArea,
    CardContent,
    makeStyles,
    Typography,
} from "@material-ui/core"
import { Loyalty as LoyaltyIcon } from "@material-ui/icons/"
import { Rating } from "@material-ui/lab"
import { useContext } from "react"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import SiteContext from "../../../contexts/SiteContext"
import { useTextos } from "../../../contexts/TextosContext"
import { formatarParaDinheiro } from "../../../services/functions"

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: props => props.aplicativoDados.corSitePrimaria + "44",
        marginBottom: "1rem",
    },
    contentContainer: {
        padding: "0.5rem",
        display: "grid",
        gap: "0.5rem",
        justifyContent: "center",
        alignItems: "center",
        justifyItems: "center",
        gridTemplateAreas: `
        "texto texto"
        "selos selos"
        "minimo-selo minimo-selo"
        "validade botao"
        `,
        [theme.breakpoints.down("xs")]: {
            gap: "0.25rem",
        },
        "& > .card-fidelidade-texto": {
            gridArea: "texto",
            display: "flex",
            gap: "0.25rem",
            [theme.breakpoints.down("xs")]: {
                flexDirection: "column",
                gap: "0",
            },
        },
        "& > .card-fidelidade-selos": {
            gridArea: "selos",
            alignSelf: "center",
            "& .MuiRating-iconFilled": {
                color: props => props.aplicativoDados.corSitePrimaria, //props => props.aplicativoDados?.corSiteSecundaria,
            },
        },
        "& > .card-fidelidade-validade": {
            gridArea: "validade",
        },
        "& > .card-fidelidade-minimo": {
            gridArea: "minimo-selo",
        },
        "& > .card-fidelidade-botao": {
            gridArea: "botao",
        },
    },
    buttonContainer: {
        paddingTop: 0,
        justifyContent: "space-between",
        "& > button": {
            color: props => props.aplicativoDados.corSitePrimaria,
        },
    },
}))

export default function CartelaAtual(props) {
    const { aplicativoDados, usuarioLogado } = useContext(SiteContext)
    const classes = useStyles({ aplicativoDados })
    const history = useHistory()
    const textos = useTextos()

    if (!usuarioLogado || !usuarioLogado.cartelas) return null

    const cartela =
        usuarioLogado.cartelas.find(
            c => c.status === 1 && c.promocaoFidelidade.exibirPublicamente
        ) ||
        usuarioLogado.cartelas.find(c => c.status === 0 && c.promocaoFidelidade.exibirPublicamente)

    if (!cartela) return null

    const quantidadeSelos = cartela.selos.length
    const promocaoFidelidade = cartela.promocaoFidelidade

    const arrayMaxima = []
    let resto = promocaoFidelidade.quantidadeNecessaria
    while (resto > 0) {
        arrayMaxima.push(Math.min(resto, 10))

        resto -= 10
    }

    const arrayIteravel = []
    resto = quantidadeSelos
    while (resto > 0) {
        arrayIteravel.push(Math.min(resto, 10))

        resto -= 10
    }

    const cartelaCompleta = quantidadeSelos === promocaoFidelidade.quantidadeNecessaria
    const isPontuarPorValor = promocaoFidelidade.valorPorSelo !== null

    return (
        <Card className={classes.container} elevation={0}>
            <CardActionArea onClick={() => history.push("/delivery/fidelidade")}>
                <CardContent className={classes.contentContainer}>
                    <Typography variant="body2" align="center" className="card-fidelidade-texto">
                        <span style={{ display: "block" }}>
                            {cartelaCompleta ? textos.voceJuntou : textos.junteMais}{" "}
                            <span className="bold">
                                {cartelaCompleta
                                    ? promocaoFidelidade.quantidadeNecessaria
                                    : promocaoFidelidade.quantidadeNecessaria - quantidadeSelos}
                            </span>{" "}
                            {cartelaCompleta ? textos.selosEGanhou : textos.selosEGanhe}{" "}
                        </span>
                        <span className="bold">
                            {cartela.promocaoFidelidade.premio}
                            {promocaoFidelidade.freteGratisCartelaCompleta ? " + Frete Grátis" : ""}
                        </span>
                    </Typography>
                    {promocaoFidelidade.valorConsumoMinimoParaSelo > 0 ? (
                        <Typography
                            variant="caption"
                            align="center"
                            className="card-fidelidade-minimo"
                        >
                            {isPontuarPorValor ? textos.minimoObterSelo2 : textos.minimoObterSelo1}{" "}
                            {formatarParaDinheiro(promocaoFidelidade.valorConsumoMinimoParaSelo)}
                        </Typography>
                    ) : null}
                    {arrayMaxima.map((param, index) => (
                        <Rating
                            max={param}
                            value={arrayIteravel[index]}
                            readOnly
                            className="card-fidelidade-selos"
                            icon={<LoyaltyIcon />}
                        />
                    ))}
                    <Typography variant="caption" className="card-fidelidade-validade">
                        Val.: {cartela.dataValidade}
                    </Typography>
                    <Button size="small" className="card-fidelidade-botao">
                        {textos.verDetalhes}
                    </Button>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}
